/**
 * Returns the number of items to render per segment row.
 * Segments should have a balanced number of items per row.
 * Example 1: If there are 16 items to render and 2 rows, then 8 items should be rendered per row.
 * Example 2: If there are 13 items to render and 2 rows, then 7 items should be rendered per row.
 * Example 3: If there are 5 items to render and 2 rows, then 3 items should be rendered per row.
 * @param segmentSize
 * @param productsCount
 * @param segmentRows
 */
export function getSegmentItemsPerRowCount({
  productsCount,
  segmentSize,
  segmentRows,
}: {
  productsCount: number;
  segmentSize: number;
  segmentRows: number;
}) {
  const productsToRender =
    segmentSize > productsCount ? productsCount : segmentSize;

  return Math.ceil(productsToRender / segmentRows);
}
